import api from '../axios/axiosInstance';

const getCurrency = async () => {
  const response = await api.get('users/currency');
  return response.data;
};

export default getCurrency;
